import { render, staticRenderFns } from "./quickReply.vue?vue&type=template&id=695f5c62&scoped=true"
import script from "./quickReply.vue?vue&type=script&lang=js"
export * from "./quickReply.vue?vue&type=script&lang=js"
import style0 from "./quickReply.vue?vue&type=style&index=0&id=695f5c62&prod&lang=less&scoped=true"
import style1 from "./quickReply.vue?vue&type=style&index=1&id=695f5c62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695f5c62",
  null
  
)

export default component.exports